module.exports = __webpack_public_path__ + "static/media/banner.d6eec562.jpg";